import React, { useEffect, useState } from 'react';
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    Grid,
    Select,
    MenuItem,
    TextField,
    Typography,
    FormControlLabel
} from '@mui/material';
import axios from 'axios';
import { token, apiUrl } from '../../../../../api';
import api from '../../../../services/api';

const API_BASE = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000';

const SwitchboardIntegrationNew = ({ onClose }) => {
    //? --------------------------- DEFININDO AS VARIAVEIS INICIAIS ---------------------------
    const [status, setStatus] = useState({ type: '', message: '' });
    const [app, setApp] = useState(null);
    const [listaApps, setListaApps] = useState([]);
    const [reloadSwitchboardsIntegrations, setReloadSwitchboardsIntegrations] = useState(false);
    const [listaIntegrations, setListaIntegrations] = useState([]);
    const [listaChatbots, setListaChatbots] = useState([]);
    const [listaSwitchboards, setListaSwitchboards] = useState([]);
    const [mostrarSwitchboardIntegrations, setMostrarSwitchboardIntegrations] = useState(false);
    const [listaSwitchboardsIntegrations, setListaSwitchboardsIntegrations] = useState([]);
    const [appFoiSelecionado, setAppFoiSelecionado] = useState(false);
    const [integrationFoiSelecionado, setIntegrationFoiSelecionado] = useState(false);
    const [switchboardFoiSelecionado, setSwitchboardFoiSelecionado] = useState(false);
    const [mostrarInfoSwInt, setMostrarInfoSwInt] = useState(false);
    const [dadosSwSelecionado, setDadodSwSelecionado] = useState([]);
    const [selecionouDefaultResponder, setSelecionouDefaultResponder] = useState(false);
    const [wizardData, setWizardData] = React.useState({
        app: {
            name: '',
            id: ''
        },
        switchboardIntegration: {
            id: '',
            name: '',
            type: '',
            integrationId: '',
            default_responder_id: '',
            default_responder_name: ''
        }
    });

    //? --------------------------- MANIPULANDO FORMULÁRIO ---------------------------
    const handleAppChange = (e) => {
        setWizardData((prev) => ({
            ...prev,
            app: { ...prev.app, id: e.target.value }
        }));
        setAppFoiSelecionado(true);
        setMostrarSwitchboardIntegrations(true);
    };

    // const handleIntegrationChange = (e) => {
    //     setWizardData((prev) => ({
    //         ...prev,
    //         integration: { ...prev.integration, id: e.target.value }
    //     }));
    //     setIntegrationFoiSelecionado(true);
    // };

    // const handleSwitchboardChange = (e) => {
    //     setWizardData((prev) => ({
    //         ...prev,
    //         switchboard: { ...prev.switchboard, id: e.target.value }
    //     }));
    //     setSwitchboardFoiSelecionado(true);
    // };

    const handleNewSwitchboardIntegrationChange = () => {
        setMostrarSwitchboardIntegrations(false);
        setAppFoiSelecionado(true);
    };

    useEffect(() => {
        loadSwitchboardIntegrations();
    }, [appFoiSelecionado]);

    // const handleChange = (e) => {
    //     console.log('handleChange chamado');
    //     const { name, value } = e.target;
    //     console.log(`name: ${name}, value: ${value}`);

    //     const newData = {
    //         ...wizardData,
    //         [name]: {
    //             ...wizardData[name],
    //             id: value
    //         }
    //     };

    //     console.log(`newData: ${JSON.stringify(newData)}`);

    //     if (name === 'app') {
    //         setAppFoiSelecionado(true);
    //         setMostrarSwitchboardIntegrations(true);
    //     }

    //     if (name === 'integration') {
    //         setIntegrationFoiSelecionado(true);
    //     }

    //     if (name === 'switchboard') {
    //         setSwitchboardFoiSelecionado(true);
    //     }

    //     setWizardData(newData);
    // };

    //? --------------------------- LISTANDO APPS ---------------------------
    // useEffect(() => {
    //     loadApps();
    //     setAppFoiSelecionado(false);
    //     setListaIntegrations([]);
    //     setIntegrationFoiSelecionado(false);
    //     setListaSwitchboards([]);
    //     setListaSwitchboardsIntegrations([]);
    // }, [wizardData.app.id]);

    useEffect(() => {
        loadApps();
    }, [appFoiSelecionado]);

    const loadApps = async () => {
        console.log('entrou em loadApps');
        try {
            const res = await api.get(`v1/apps/`);
            // const res = await axios.get(`${API_BASE}/api/v1/apps/`, {
            //     headers: {
            //         Authorization: token,
            //         'Content-Type': 'application/json'
            //     }
            // });
            if (res.data) {
                setListaApps(res.data.apps);
                console.log(`Apps carregados: ${JSON.stringify(res.data.apps)}`);
                console.log('fim da loadApps');
            } else {
                setStatus({ type: 'error', message: 'Erro ao carregar Apps' });
            }
        } catch (err) {
            console.error('Erro ao carregar Apps', err);
            setStatus({ type: 'error', message: 'Erro ao carregar Apps' });
        }
    };

    useEffect(() => {
        if (listaApps.length > 0 && !wizardData.app.id) {
            setWizardData((prev) => ({
                ...prev,
                app: {
                    ...prev.app,
                    id: listaApps[0].id
                }
            }));
            setAppFoiSelecionado(true);
            setMostrarSwitchboardIntegrations(true);
        }
    });

    //? --------------------------- LISTANDO SWITCHBOARDS INTEGRATIONS ---------------------------
    useEffect(() => {
        loadSwitchboardIntegrations();
    }, [appFoiSelecionado, wizardData.app.id, mostrarSwitchboardIntegrations]);

    useEffect(() => {
        if (!wizardData.app.id) return;
        loadIntegrations();
        loadChatbots();
    }, [wizardData.app.id]);

    const loadIntegrations = async () => {
        try {
            const res = await api.get(`v1/apps/${wizardData.app.id}/integrations/`);
            setListaIntegrations(res.data?.integrations || []);
        } catch (err) {
            console.error('Erro ao carregar Integrations', err);
        }
    };

    const loadChatbots = async () => {
        try {
            const res = await api.get(`v1/apps/${wizardData.app.id}/chatbots/`);
            setListaChatbots(res.data || []);
        } catch (err) {
            console.error('Erro ao carregar Chatbots', err);
        }
    };

    const loadSwitchboardIntegrations = async () => {
        console.log('entrou em loadSwitchboardIntegrations');
        if (!wizardData.app.id || !listaIntegrations || !listaSwitchboards) return;
        try {
            const response = await api.get(`v1/apps/${wizardData.app.id}/switchboardIntegrations/`);

            console.log('Dados processados:', response.data);

            const integrations = response.data.switchboardIntegrations || [];

            setListaSwitchboardsIntegrations(integrations);
        } catch (err) {
            console.error('Erro ao carregar Switchboard Integrations', err);
            setStatus({ type: 'error', message: 'Erro ao carregar Switchboard Integrations' });
        }
    };

    //? --------------------------- CRIANDO O SWITCHBOARD --------------------------
    const createSwitchboardIntegrations = async () => {
        console.log('createSwitchboardIntegrations - entrou');

        try {
            const payload = {
                name: wizardData.switchboardIntegration.name,
                integrationType: wizardData.switchboardIntegration.type,
                integrationId: wizardData.switchboardIntegration.integrationId || null,
                deliverStandbyEvents: 'True'
            };

            console.log('Payload do switchboard Integrations:', JSON.stringify(payload));

            console.log(`createSwitchboard - URL: v1/apps/${wizardData.app.id}/switchboardIntegrations/`);

            const res = await api.post(`v1/apps/${wizardData.app.id}/switchboardIntegrations/`, payload);

            if (res.data) {
                setStatus({ type: 'success', message: 'Switchboard Integrations criado com sucesso!' });
                console.log(`switchboard Integrations ${res.data.id} criado com sucesso!`);
                setMostrarInfoSwInt(false);
                setMostrarSwitchboardIntegrations(true);
            } else {
                console.log(`switchboard Integrations caiu no else`);
                setStatus({ type: 'error', message: 'Erro ao criar Switchboard Integrations' });
            }
        } catch (error) {
            console.error('Erro ao criar Switchboard Integrations', error.response?.data || error);
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || 'Erro ao criar switchboard Integrations.'
            });
        }
    };

    const deleteSwitchboardIntegration = async () => {
        console.log('deleteSwitchboardIntegration - entrou');

        const res = await api.delete(`v1/apps/${wizardData.app.id}/switchboardIntegrations/${dadosSwSelecionado.id}/`);

        if (res.data) {
            setStatus({ type: 'success', message: 'Switchboard Integrations excluído com sucesso!' });
            setMostrarInfoSwInt(false);
            setMostrarSwitchboardIntegrations(true);
        } else {
            setStatus({ type: 'error', message: 'Erro ao excluir Switchboard Integrations' });
        }
    };

    const handleInfoSw = () => {
        console.log('handleInfoSw - entrou');
        setMostrarInfoSwInt(true);
        setMostrarInfoSwInt(false);
    };

    const handleSwitchboardIntegrationChange = (e) => {
        const selectedId = e.target.value;

        const selectedIntegration = listaSwitchboardsIntegrations.find((sw) => sw.id === selectedId);

        if (!selectedIntegration) return;

        setWizardData((prev) => ({
            ...prev,
            switchboardIntegration: {
                ...prev.switchboardIntegration,
                default_responder_id: selectedIntegration.id,
                default_responder_name: selectedIntegration.name,
                type: selectedIntegration.integrationType
            }
        }));

        // if (wizardData.switchboardIntegration.default_responder_id) {
        setSelecionouDefaultResponder(true);
        // }
    };

    const atualizaSwitchboardIntegrations = async () => {
        console.log('atualizaSwitchboardIntegrations - entrou');

        const payload = {
            // name: wizardData.switchboardIntegration.name,
            // integrationType: wizardData.switchboardIntegration.type,
            // deliverStandbyEvents: 'True',
            nextSwitchboardIntegrationId: wizardData.switchboardIntegration.default_responder_id,
            integrationId: wizardData.switchboardIntegration.integrationId || null
        };

        const res = await api.patch(`v1/apps/${wizardData.app.id}/switchboardIntegrations/${dadosSwSelecionado.id}/`, payload);

        if (res.data) {
            setStatus({ type: 'success', message: 'Switchboard Integrations Atualizado!' });
            // console.log(`switchboard Integrations ${res.data.id} criado com sucesso!`);
            setMostrarInfoSwInt(false);
            setMostrarSwitchboardIntegrations(true);
        } else {
            console.log(`switchboard Integrations caiu no else`);
            setStatus({ type: 'error', message: 'Erro ao atualizar Switchboard Integrations' });
        }
    };

    return (
        <Card>
            <CardContent>
                {status.message && (
                    <Alert severity={status.type} sx={{ mb: 2 }}>
                        {status.message}
                    </Alert>
                )}

                <Typography variant="h2">Switchboard Integrations (Humano, BOT)</Typography>

                {/* Select App */}
                <Grid item xs={12} sm={6} marginTop={3}>
                    <TextField select label="Selecione o App" value={wizardData.app.id} onChange={handleAppChange} fullWidth>
                        {listaApps.map((app) => (
                            <MenuItem key={app.id} value={app.id}>
                                {app.displayName}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                {mostrarSwitchboardIntegrations && !mostrarInfoSwInt && (
                    <CardContent>
                        <Typography variant="h4" marginTop={3} sx={{ mt: 2, mb: 2 }}>
                            Confira seus Switchboard Integrations
                        </Typography>
                        {/* Cabeçalho */}
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '80px 200px 150px 50px',
                                fontWeight: 'bold',
                                pb: 1,
                                borderBottom: '2px solid #eee',
                                marginTop: 3
                            }}
                        >
                            <Typography>Nome</Typography>
                            <Typography>ID</Typography>
                            <Typography>Tipo</Typography>
                            <Typography>Responde</Typography>
                        </Box>

                        {/* Linhas da tabela */}
                        {listaSwitchboardsIntegrations.map((switchboardIntegration) => (
                            <Box
                                key={switchboardIntegration.id}
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '80px 200px 150px 50px',
                                    borderBottom: '1px solid #f0f0f0',
                                    py: 1,
                                    alignItems: 'center',
                                    cursor: 'pointer'
                                }}
                                onClick={(e) => {
                                    console.log('clicou no switchboard integration:', switchboardIntegration);
                                    setDadodSwSelecionado(switchboardIntegration);
                                    setWizardData((prev) => ({
                                        ...prev,
                                        switchboardIntegration: {
                                            ...prev.switchboardIntegration,
                                            id: switchboardIntegration.id,
                                            name: switchboardIntegration.name,
                                            type: switchboardIntegration.integrationType,
                                            integrationId: switchboardIntegration.integrationId || '',
                                            default_responder_id: switchboardIntegration.nextSwitchboardIntegrationId_id?.id || ''
                                        }
                                    }));
                                    handleInfoSw();
                                    setMostrarInfoSwInt(true);
                                    setMostrarSwitchboardIntegrations(false);
                                    // setOpenInfoApp(true);
                                    // setDetalhesApp(app);

                                    // if (e.target.tagName !== 'INPUT' && !e.target.dataset.org) {
                                    //     handleOpenUser(user);
                                    // }
                                }}
                            >
                                {/* Nome */}
                                <Typography>{switchboardIntegration.name}</Typography>
                                {/* ID */}
                                <Typography>{switchboardIntegration.id || '—'}</Typography>
                                {/* Tipo */}
                                {switchboardIntegration.integrationType === 'system' && <Typography>Sistema</Typography>}
                                {switchboardIntegration.integrationType === 'custom' && <Typography>Personalizado</Typography>}

                                <Typography>{switchboardIntegration.nextSwitchboardIntegrationId_id?.name || '—'}</Typography>
                            </Box>
                        ))}
                    </CardContent>
                )}

                {!mostrarSwitchboardIntegrations && appFoiSelecionado && !mostrarInfoSwInt && (
                    <>
                        <Typography variant="h6" sx={{ mt: 2 }}>
                            Tipo do Agente
                        </Typography>
                        <Select
                            fullWidth
                            label="Tipo do Agente"
                            color="primary"
                            value={wizardData.switchboardIntegration.type}
                            onChange={(e) =>
                                setWizardData({
                                    ...wizardData,
                                    switchboardIntegration: {
                                        ...wizardData.switchboardIntegration,
                                        type: e.target.value
                                    }
                                })
                            }
                        >
                            <MenuItem value="system">Sistema</MenuItem>
                            {/* <MenuItem value="human">Humano</MenuItem> */}
                            <MenuItem value="custom">Personalizado</MenuItem>
                        </Select>

                        <TextField
                            label="Nome do Switchboard Integration"
                            fullWidth
                            margin="normal"
                            value={wizardData.switchboardIntegration.name}
                            onChange={(e) =>
                                setWizardData({
                                    ...wizardData,
                                    switchboardIntegration: { ...wizardData.switchboardIntegration, name: e.target.value }
                                })
                            }
                        />

                        {wizardData.switchboardIntegration.type === 'custom' && (
                            <TextField
                                select
                                fullWidth
                                margin="normal"
                                label="Chatbot que responde"
                                value={wizardData.switchboardIntegration.integrationId || ''}
                                onChange={(e) =>
                                    setWizardData({
                                        ...wizardData,
                                        switchboardIntegration: { ...wizardData.switchboardIntegration, integrationId: e.target.value }
                                    })
                                }
                            >
                                <MenuItem value="">Selecione</MenuItem>
                                {Array.isArray(listaChatbots) &&
                                    listaChatbots.map((cb) => (
                                        <MenuItem key={cb.id} value={cb.id}>
                                            {cb.name}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        )}

                        {wizardData.switchboardIntegration.type === 'system' && (
                            <TextField
                                select
                                fullWidth
                                margin="normal"
                                label="Integration (canal) do fluxo"
                                value={wizardData.switchboardIntegration.integrationId || ''}
                                onChange={(e) =>
                                    setWizardData({
                                        ...wizardData,
                                        switchboardIntegration: { ...wizardData.switchboardIntegration, integrationId: e.target.value }
                                    })
                                }
                            >
                                <MenuItem value="">Selecione</MenuItem>
                                {Array.isArray(listaIntegrations) &&
                                    listaIntegrations.map((i) => (
                                        <MenuItem key={i.id} value={i.id}>
                                            {i.displayName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        )}
                    </>
                )}

                {mostrarInfoSwInt && !mostrarSwitchboardIntegrations && (
                    <>
                        <Typography variant="h3" marginTop={5}>
                            {dadosSwSelecionado.name}
                        </Typography>

                        {/* Select App */}
                        <Grid item xs={12} sm={6} marginTop={3}>
                            <TextField
                                select
                                required
                                label="Definir quem responde:"
                                value={wizardData.switchboardIntegration.default_responder_id}
                                onChange={handleSwitchboardIntegrationChange}
                                fullWidth
                            >
                                {listaSwitchboardsIntegrations.map((sw) => (
                                    <MenuItem key={sw.id} value={sw.id}>
                                        {sw.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {wizardData.switchboardIntegration.type === 'custom' && (
                            <Grid item xs={12} sm={6} marginTop={3}>
                                <TextField
                                    select
                                    label="Chatbot que responde"
                                    value={wizardData.switchboardIntegration.integrationId || ''}
                                    onChange={(e) => {
                                        setWizardData((prev) => ({
                                            ...prev,
                                            switchboardIntegration: {
                                                ...prev.switchboardIntegration,
                                                integrationId: e.target.value
                                            }
                                        }));
                                        setSelecionouDefaultResponder(true);
                                    }}
                                    fullWidth
                                >
                                    <MenuItem value="">Selecione</MenuItem>
                                    {Array.isArray(listaChatbots) &&
                                        listaChatbots.map((cb) => (
                                            <MenuItem key={cb.id} value={cb.id}>
                                                {cb.name}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </Grid>
                        )}

                        {/* Escolhe o Default Responder */}
                        {/* <CardContent> */}
                        {/* <Grid xs={12} marginTop={5} maxWidth={200} marginLeft={0} backgroundColor="#fdfdfdff">
                            <Typography>Definir quem responde:</Typography>
                            <TextField
                                select
                                required
                                label="Responder"
                                fullWidth
                                value={wizardData.switchboardIntegration.default_responder_id}
                                onChange={handleSwitchboardIntegrationChange}
                                margin="dense"
                            >
                                {listaSwitchboardsIntegrations.map((sw) => (
                                    <MenuItem key={sw.id} value={sw.id}>
                                        {sw.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid> */}
                        {/* </CardContent> */}

                        <Button
                            variant="outlined"
                            sx={{ mr: 1, mt: 3, backgroundColor: '#dba08a' }}
                            color="secondary"
                            onClick={deleteSwitchboardIntegration}
                        >
                            Apagar
                        </Button>
                    </>
                )}

                {appFoiSelecionado && mostrarSwitchboardIntegrations && !mostrarInfoSwInt && (
                    <Box sx={{ mt: 2 }}>
                        <Button sx={{ ml: 2 }} variant="outlined" color="secondary" onClick={onClose}>
                            Voltar
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleNewSwitchboardIntegrationChange}
                            sx={{ ml: 2, mr: 0, backgroundColor: '#32CD32' }}
                        >
                            Criar Novo
                        </Button>
                    </Box>
                )}

                {!mostrarSwitchboardIntegrations && appFoiSelecionado && !mostrarInfoSwInt && (
                    <>
                        <Box sx={{ mt: 2, mr: 2 }}>
                            <Button variant="contained" onClick={createSwitchboardIntegrations} sx={{ mr: 1, backgroundColor: '#32CD32' }}>
                                Enviar
                            </Button>
                            <Button variant="outlined" color="secondary" onClick={onClose}>
                                Voltar
                            </Button>
                        </Box>
                    </>
                )}

                {selecionouDefaultResponder && (
                    <>
                        <Button
                            sx={{ marginTop: 3, backgroundColor: '#32CD32' }}
                            variant="outlined"
                            color="secondary"
                            onClick={atualizaSwitchboardIntegrations}
                        >
                            Salvar
                        </Button>

                        <Button sx={{ marginTop: 3, marginLeft: 1 }} variant="outlined" color="secondary" onClick={onClose}>
                            Voltar
                        </Button>
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export default SwitchboardIntegrationNew;
